import Theme from './Theme';


const config = {
  'theme': Theme,
};

export default config;



// WEBPACK FOOTER //
// ./src/config/config.js